import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { SessionStorage } from '../../burger-king-lib/utils/storage.web';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';
import { trackEvent } from '../../../analytics_wrapper';
import {
  homepage,
  kingdeals_homepage,
  nearbystore_homepage
} from '../../../analyics_constants';
import { ROUTES as _routes } from '../../constants/app-constants';

function withMobileHeaderFooterAdding(Component) {
  return function MobieLayoutComponent(props) {
    const [isMobileScreen, setisMobileScreen] = useState(
      window.innerWidth <= 1023
    );
    const [activeKey, setActiveKey] = useState('');
    const history = useHistory();
    const location = useLocation();

    const goBackOnClick = path => {
      history.replace(path || '/');
    };

    const isAccountScreen = useMemo(() =>{
      return location.pathname?.includes('/account/')
    },[location])

    const mobileFooterClickHandler = key => {
      const addressInfo = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
      if (key === 'home') {
        history.push(_routes.HOME);
        setActiveKey('home');
        trackEvent(homepage, {
          order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
          city: addressInfo?.city ? addressInfo?.city : '',
          crown_points: window.localStorage.getItem('crowns')
            ? window.localStorage.getItem('crowns')
            : 0
        });
      }
      if (key === 'offers') {
        history.push(_routes.OFFERS);
        setActiveKey('offers');
        trackEvent(kingdeals_homepage, {
          order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
          city: addressInfo?.city ? addressInfo?.city : '',
          crown_points: window.localStorage.getItem('crowns')
            ? window.localStorage.getItem('crowns')
            : 0
        });
      }
      if (key === 'stores') {
        history.push(_routes.STORE_LOCATOR);
        setActiveKey('stores');
        trackEvent(nearbystore_homepage, {
          order_mode: SessionStorage.get(LocalSessionKey.ORDER_TYPE),
          city: addressInfo?.city ? addressInfo?.city : '',
          crown_points: window.localStorage.getItem('crowns')
            ? window.localStorage.getItem('crowns')
            : 0,
          store_name: addressInfo?.outlet_name,
          store_id: SessionStorage.get(LocalSessionKey.OUTLET_ID)
        });
      }
    };

    const handleResize = useCallback(() => {
      setisMobileScreen(window.innerWidth <= 1023);
    }, []);

    useEffect(() => {
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
      <Component
        {...props}
        goBackOnClick={goBackOnClick}
        activeKey={activeKey}
        mobileFooterClickHandler={mobileFooterClickHandler}
        isMobileScreen={isMobileScreen}
        isAccountScreen = {isAccountScreen}
      />
    );
  };
}

export default withMobileHeaderFooterAdding;
